import { forwardRef } from 'react';

import Button from 'components/field/Button';

import { faClose } from '@fortawesome/pro-solid-svg-icons';

import Icon from './Icon';
import Typography from './Typography';
import * as S from './styled/Tag.styled';

const Tag = ({ variant = 'default', className, icon, label, onClose, children, ...moreProps }, ref) => (
	<S.Container ref={ref} className={`tag ${variant} ${className ?? ''}`} {...moreProps}>
		{icon && <Icon icon={icon} />}
		{label && <Typography fontWeight="500">{label}</Typography>}
		{children}
		{onClose && (
			<Button
				variant="transparent"
				color="var(--content-3)"
				icon={faClose}
				onClick={onClose}
				iconButton
				size="x-small"
			/>
		)}
	</S.Container>
);

export default forwardRef(Tag);
